import BaseLevelScene from './BaseLevelScene';
import { Bullet } from 'src/classes/SlingShot';

export default class PoeMuseumScene extends BaseLevelScene {
  tileWidth: integer = 16;
  tileHeight: integer = 16;
  overlay: Phaser.Tilemaps.TilemapLayer;
  heartbeatSound: Phaser.Sound.BaseSound;
  stuff: Phaser.Tilemaps.TilemapLayer;
  heartPosition: MatterJS.Vector;
  constructor() {
    super('Poe Museum');
  }

  preload() {

    // Preload base level
    this.preloadBaseLevel();

    // load the train PNG file
    this.load.image('medieval_interior_tiles', 'assets/sourceImages/medieval tileset interior.png');

    // load the JSON map
    this.load.tilemapTiledJSON(
      'poe_museum_tilemap',
      'assets/scenes/OldStoneHouse.json'
    );

    // load heartbeat sound
    this.load.audio('heartbeat_sound', 'assets/audio/heartbeat_slow_0_single.mp3');
  }

  removeTile(tile: Phaser.Tilemaps.Tile, tileBody: Phaser.GameObjects.GameObject){
    this.overlay.removeTileAt(tile.x, tile.y);
    // tileBody.removeBody();
    tileBody.destroy();
  }

  hitOverlay (tile: Phaser.Tilemaps.Tile, collisionData: Phaser.Types.Physics.Matter.MatterCollisionData): boolean
  {
    if(collisionData.bodyA.label === "bulletCollider"){
      const bulletBody: Bullet = collisionData.bodyA.gameObject as Bullet;
      bulletBody.disableBullet();
      const tileBody = collisionData.bodyB.gameObject;//  as Phaser.Physics.Matter.TileBody; 
      this.removeTile(tile, tileBody);
    }
    else if(collisionData.bodyB.label === "bulletCollider"){
      const bulletBody: Bullet = collisionData.bodyB.gameObject as Bullet;
      bulletBody.disableBullet();
      const tileBody = collisionData.bodyA.gameObject;
      this.removeTile(tile, tileBody);
    }
    // Return true to exit processing collision of this tile vs the sprite - in this case, it
    // doesn't matter since the coin ti      this.heartbeatSound.stop();les are not set to collide.
    return false;
  }

  getHearts(): Array<Phaser.GameObjects.GameObject>{
    return this.children.list.filter((gameObject) => {
      if(gameObject.type === "Sprite"){
        const isHeart: boolean = (gameObject as Phaser.Physics.Matter.Sprite).texture["key"] === "heart_gem";
        return isHeart;
      }
      else{
        return false;
      }
    });
  }

  getHeartToPlayerDist(){
    return Phaser.Math.Distance.Between(this.player.x, this.player.y, this.heartPosition.x, this.heartPosition.y);
  }

  getHeartbeatVolume(offset=100){
    return Math.max((offset - this.getHeartToPlayerDist()/2)/offset, 0.4)
  }

  getHeartbeatDelay(scalar=25){
    return Math.min(this.getHeartToPlayerDist()*scalar, 3500);
  }

  create() {
    // 👌 sanity check by displaying the entire tileset image
    // this.add.image(0, 0, 'sewer_tiles');

    // create the Tilemap
    this.map = this.make.tilemap({ key: 'poe_museum_tilemap' });

    // add the tileset  images we are using
    const baseTileset = this.map.addTilesetImage('medieval_interior', 'medieval_interior_tiles');

    // create the layers we want in the right order
    const floor = this.map.createLayer('BaseLayer', baseTileset);
    this.map.setCollisionByProperty({collides: true});
    this.matter.world.convertTilemapLayer(floor);

    // add any additional textures over the base layer
    const textures = this.map.createLayer('Textures', baseTileset);
    this.map.setCollisionByProperty({collides: true});
    this.matter.world.convertTilemapLayer(textures);

    // add furniture
    const furniture = this.map.createLayer('Furniture', baseTileset);
    this.map.setCollisionByProperty({collides: true});
    this.matter.world.convertTilemapLayer(furniture);

    // add miscelaneous stuff
    this.stuff = this.map.createLayer('Stuff', baseTileset);
    this.map.setCollisionByProperty({collides: true});
    this.matter.world.convertTilemapLayer(this.stuff);
    
    // create base level
    this.createBaseLevel(0.4, 4);

    // add overlay layer on top of items to hide them
    this.createOverlayLayer(this.map, baseTileset, this.hitOverlay);


    // Get the heart StoryItem
    this.heartPosition = this.getHearts()[0].body.position;

    // Compute the distance between the player and the heart

    // Add beating heart sound
    this.heartbeatSound = this.sound.add('heartbeat_sound');
    this.sound.get('heartbeat_sound').on('complete', () => {
      console.log("Setting timeout");
      setTimeout(
          () => {
            if(this.getHearts().length > 0){
              console.log(`playing heartbeat with volume: ${this.getHeartbeatVolume()}`);
              this.heartbeatSound.play({mute: false, volume: this.getHeartbeatVolume()});
            }
          },
          this.getHeartbeatDelay()/// Delay
        )
      }
    )
    this.heartbeatSound.play();
  }
}
